
        <div class="ngx-gallery-arrow-wrapper ngx-gallery-arrow-left">
            <i class="ngx-gallery-icon ngx-gallery-arrow {{arrowPrevIcon}}" aria-hidden="true" (click)="handlePrevClick()" [class.ngx-gallery-disabled]="prevDisabled"></i>
        </div>
        <div class="ngx-gallery-arrow-wrapper ngx-gallery-arrow-right">
            <i class="ngx-gallery-icon ngx-gallery-arrow {{arrowNextIcon}}" aria-hidden="true" (click)="handleNextClick()" [class.ngx-gallery-disabled]="nextDisabled"></i>
        </div>
    